import { render } from "./spot.vue?vue&type=template&id=274feeba&scoped=true"
import script from "./spot.vue?vue&type=script&lang=js"
export * from "./spot.vue?vue&type=script&lang=js"

import "./spot.vue?vue&type=style&index=0&id=274feeba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274feeba"]])

export default __exports__